<template>
    <div>
        <div class="avatar">
            <span v-if="!avatar">{{ getInitials() }}</span>
            <img v-else :src="avatar" alt="avatar" class="avatar-img" height="40" width="40"/>
        </div>
        <div class="user-detail-row">
            <span class="text-muted">Worker ID:</span><span class="user-value"> {{ user.id ? user.id : "-" }}</span>
        </div>
        <div class="user-detail-row">
            <span class="text-muted">Email:</span><span class="user-value"> {{ user.email ? user.email : "-" }}</span>
        </div>
        <div class="user-detail-row">
            <span class="text-muted">Organization:</span><span class="user-value"> {{ user.organization ? user.organization.name : "-" }}</span>
        </div>
    </div>
</template>
<script>
    import avatarManager from '../../utils/avatarManager.js'

    export default {
        name: 'UserDetails',
        data() {
            return {
                avatar: null
            }
        },
        props: {
            user: {
                type: Object,
                required: false
            }
        },
        methods: {
            getInitials() { 
                return avatarManager.getAvatar(this.user, (avatarUrl) => {
                    this.avatar = avatarUrl;
                });
            }
        },
        watch: {
            user: {
                handler() {
                    this.getInitials();
                },
                deep: true
            }
        }
    }
</script>  
<style scoped>
    .avatar {
        width: 3.5rem;
        height: 3.5rem;
        border-radius: 5px;
        background-color: #146F70;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 1.6rem;
    }
    .user-value {
        color: #282828;
        font-size: 1.4rem;
    }
    .user-detail-row {
        padding: 0.5rem 0;
    }
    .mr-3 {
        margin-right: 1rem;
    }
    .text-muted {
        font-size: 1.4rem;
    }
</style>